import React from 'react';
import {
  Modal,
  ModalContent,
  ModalFooter,
  ModalHeader,
} from '../design-system';
import { Button, Flex, Box, Text } from '../design-system';

interface StatusChangeModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  status: string | null;
}

const StatusChangeModal = ({
  open,
  onClose,
  onConfirm,
  status,
}: StatusChangeModalProps) => {
  return (
    <Modal show={open} onClose={onClose}>
      <ModalHeader>
        <Text fontSize="1.2rem" fontWeight={600}>
          Confirm Status Change
        </Text>
      </ModalHeader>
      <ModalContent>
        <Box p={1} style={{ fontSize: '1.1rem' }} maxWidth={400}>
          Are you sure you want to change this project's status to "{status}"?
          This will also update all associated actions to the same status.
        </Box>
      </ModalContent>
      <ModalFooter>
        <Flex justifyContent="flex-end">
          <Button
            aria-label="Cancel"
            type="button"
            onClick={onClose}
            variant="grey"
          >
            Cancel
          </Button>
          <Box ml={3}>
            <Button
              aria-label="Confirm Status Change"
              type="button"
              onClick={onConfirm}
            >
              Confirm
            </Button>
          </Box>
        </Flex>
      </ModalFooter>
    </Modal>
  );
};

export default StatusChangeModal;
